// extracted by mini-css-extract-plugin
export default {"trips-summary-item":"styles_trips-summary-item__w3Jgc","selected":"styles_selected__O53NS","invalid":"styles_invalid__vF+y8"};